import { i18n } from "@/i18n/i18n-setup";
export class CustomerSocial {
    public socialName: string;
    public socialUrl: string;
    public idCustomer: string;
}

const SOCIAL_LIST = [
    {text: 'YouTube', value: 'YouTube'},
    {text: 'Facebook', value: 'Facebook'},
    {text: 'Instagram', value: 'Instagram'},
    {text: 'Pinterest', value: 'Pinterest'},
    {text: 'Twitter', value: 'Twitter'},
    {text: 'LinkedIn', value: 'LinkedIn'},
    {text: 'TikTok', value: 'TikTok'},
    {text: 'SnapChat', value: 'SnapChat'},
    {text: i18n.t('GENERIC.OTHER') as string, value: 'Other'},
];

export function getDropDownSocialList(): Array<any> {
    let array: Array<any> = [];  
    array.push({ value: null, text: "" });

    SOCIAL_LIST.forEach(function (el) {
        array.push(el);
    });
    return array;
}